import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { DefaultAssignmentRegisterModal } from './DefaultAssignmentRegisterModal'

import {
    getDefaultAssignments,
    addNewDefaultAssignment,
    updateDefaultAssignment,
    updateDefaultAssignmentStatus,
    deleteDefaultAssignment,
} from '../../../store/actions'

const CatalogLayoutDefaultAssignments = (props) => {

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();

    const [searchData, setSearchData] = useState('');

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDefaultAssignments(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    useEffect(() => {
        dispatch(getDefaultAssignments('?limit=20&page=0'))
    }, [])

    const defaultAssignments = useSelector(state => state.defaultAssignments.defaultAssignments);
    const loading            = useSelector(state => state.defaultAssignments.loading);
    const total              = useSelector(state => state.defaultAssignments.total);
    const currentPage        = useSelector(state => state.defaultAssignments.currentPage);
    // * Redux fin

    const columns = React.useMemo(
        () => [
            {
                Header: 'Tipo de Proceso',
                accessor: 'assignmentType',
                width: '25%',
            },
            {
                Header: 'Tipo de Laboratorio',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.laboratoryType?.name ?? '-'}</div>
                ),
            },
            {
                Header: 'Área de Laboratorio',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.laboratoryArea?.name ?? 'Todas / N/A'}</div>
                ),
            },
            {
                Header: 'Usuario Responsable',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>
                        {row.original.user ? `${row.original.user.name ?? ''} ${row.original.user.surname ?? ''}`.trim() || '-' : '-'}
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: '10%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const getPagination = (params) => {
        dispatch(getDefaultAssignments(`${params}&search=${searchData}`))
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateDefaultAssignment(updValue))
            dispatch(updateDefaultAssignmentStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewDefaultAssignment(values))
        }
        setTimeout(() => {
            dispatch(getDefaultAssignments('?limit=20&page=0'))
        }, 500)
        setIsUpdate(false)
        setRowInfo('')
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteDefaultAssignment(rowInfo))
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='DefaultAssignmentsCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1
                                        currentPage={currentPage}
                                        getPagination={getPagination}
                                        total={total}
                                        loading={loading}
                                        isAddTableBorderStrap
                                        columns={columns}
                                        data={defaultAssignments || []}
                                    />
                                </div>

                                <DefaultAssignmentRegisterModal
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalRespInfo={RegisterModalRespInfo}
                                    isUpdate={isUpdate}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                />

                                <TableItemDeleteModal
                                    onDeleteConfirmation={onDeleteConfirmation}
                                    props={props}
                                    setShowModal={setShowModal2}
                                    showModal={showModal2}
                                    modalHeader='Eliminar regla de asignación'
                                    modalBodyLabel='¿Está seguro que desea eliminar la regla de asignación seleccionada?'
                                />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default CatalogLayoutDefaultAssignments

export { CatalogLayoutDefaultAssignments }

CatalogLayoutDefaultAssignments.propTypes = {
    history: PropTypes.any,
}
